<template>  
    <div class="accordion">  
      <slot></slot> <!-- 使用slot允许在Accordion组件内部使用AccordionItem -->  
    </div>  
  </template>  
    
  <script>  
  export default {  
    name: 'Accordion',  
    // 组件的其他选项...  
  }  
  </script>  
    
  <style scoped>  

  </style>